// Helper functies voor kleurinterpolatie
function hexToRgb(hex) {
  hex = hex.replace('#', '');
  if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
  const num = parseInt(hex, 16);
  return [num >> 16, (num >> 8) & 255, num & 255];
}
function interpolateColor(a, b, t) {
  function hex2rgb(hex) {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
    const num = parseInt(hex, 16);
    return [num >> 16, (num >> 8) & 255, num & 255];
  }
  function rgb2hex(rgb) {
    return '#' + rgb.map(x => x.toString(16).padStart(2, '0')).join('');
  }
  const c1 = hex2rgb(a);
  const c2 = hex2rgb(b);
  const c = c1.map((v, i) => Math.round(v + (c2[i] - v) * t));
  return rgb2hex(c);
}

// --- Energiehuisje helpers voor MapLibre/GeoJSON ---
// Helper: roteer (dx, dy) met hoek theta (graden)
function rotateOffset(dx, dy, theta) {
  const rad = theta * Math.PI / 180;
  return [
    dx * Math.cos(rad) - dy * Math.sin(rad),
    dx * Math.sin(rad) + dy * Math.cos(rad)
  ];
}

// Helper: zet meter-offset om naar [lng, lat] (eenvoudige ellipsoide-benadering)
const R = 6378137;
function offsetLatLng(lat, lng, dx, dy) {
  const dLat = (dy / R) * (180 / Math.PI);
  const dLng = (dx / (R * Math.cos(lat * Math.PI / 180))) * (180 / Math.PI);
  return [lng + dLng, lat + dLat]; // [lng, lat] volgorde voor GeoJSON
}

/**
 * Maakt een GeoJSON FeatureCollection voor perceel, gebouw en deuren.
 * @param {[number,number]} center    - [lat, lng]
 * @param {number} width              - m EW
 * @param {number} length             - m NS
 * @param {number} buffer             - m rondom
 * @param {Array} doorSides           - [sideN, sideE, sideS, sideW] waar elke side "" of [afstand1, deur1, afstand2, deur2, ...]
 * @param {number} doorWidth          - m
 * @param {number} rotation           - graden CW t.o.v. Noord
 * @param {Array} roosterSides        - [sideN, sideE, sideS, sideW] waar elke side "" of [afstand1, rooster1, afstand2, rooster2, ...]
 * @returns {GeoJSON.FeatureCollection}
 */
function createEnergyHouseGeoJSON(center, width, length, buffer, doorSides, doorWidth, rotation, roosterSides, MSkabelvakSides, MSkabelvakLength, LSkabelvakSides, LSkabelvakLength) {
  // buffer: [bufN, bufE, bufS, bufW]
  const [lat0, lng0] = center;
  const hw = width / 2, hl = length / 2;
  // Buffer per zijde
  let bufN, bufE, bufS, bufW;
  if (Array.isArray(buffer) && buffer.length === 4) {
    [bufN, bufE, bufS, bufW] = buffer;
  } else {
    bufN = bufE = bufS = bufW = buffer || 0;
  }
  const features = [];

  // Helpers voor offsets
  const rectOffsets = offsets => offsets.map(o => {
    const [rx, ry] = rotateOffset(o[0], o[1], rotation);
    return offsetLatLng(lat0, lng0, rx, ry);
  });

  // 1) perceel (met buffers per zijde)
  // Hoeken: volgorde NW, NO, ZO, ZW, NW
  const parcelOffsets = [
    [-hw - bufW, +hl + bufN], // NW
    [+hw + bufE, +hl + bufN], // NO
    [+hw + bufE, -hl - bufS], // ZO
    [-hw - bufW, -hl - bufS], // ZW
    [-hw - bufW, +hl + bufN]  // NW
  ];
  features.push({
    type: 'Feature',
    properties: { featuretype: 'parcel' },
    geometry: {
      type: 'Polygon',
      coordinates: [rectOffsets(parcelOffsets)]
    }
  });

  // 2) gebouw (zonder buffer)
  const buildOffsets = [[-hw, +hl], [+hw, +hl], [+hw, -hl], [-hw, -hl], [-hw, +hl]];
  features.push({
    type: 'Feature',
    properties: { featuretype: 'building' },
    geometry: {
      type: 'Polygon',
      coordinates: [rectOffsets(buildOffsets)]
    }
  });

  // 3) deuren - nieuwe flexibele positiebepaling
  doorSides.forEach(
      (sideConfig, sideIndex) => {
    if (!sideConfig || sideConfig === "" || sideConfig.length === 0) return;

    // Bepaal zijde eigenschappen
    const sideProps = [
      { start: [-hw, +hl], end: [+hw, +hl], axis: 'x' }, // Noord (0)
      { start: [+hw, +hl], end: [+hw, -hl], axis: 'y' }, // Oost (1)
      { start: [+hw, -hl], end: [-hw, -hl], axis: 'x' }, // Zuid (2)
      { start: [-hw, -hl], end: [-hw, +hl], axis: 'y' }  // West (3)
    ][sideIndex];

    // Parse array: [afstand1, deur1, afstand2, deur2, ...]
    let currentPos = 0;
    let doorIndex = 0;
    for (let i = 0; i < sideConfig.length; i += 2) {
      const distance = sideConfig[i] || 0;
      const doorLen = sideConfig[i + 1];

      currentPos += distance;
      if (doorLen && doorLen > 0) {
        // Bereken deur posities op deze zijde
        let p1, p2;

        if (sideProps.axis === 'x') {
          // Horizontale zijde (Noord/Zuid)
          const x1 = -hw + currentPos;
          const x2 = x1 + doorLen;
          p1 = [x1, sideProps.start[1]];
          p2 = [x2, sideProps.start[1]];
        } else {
          // Verticale zijde (Oost/West)
          const y1 = hl - currentPos;
          const y2 = y1 - doorLen;
          p1 = [sideProps.start[0], y1];
          p2 = [sideProps.start[0], y2];
        }

        const line = [p1, p2].map(o => {
          const [rx, ry] = rotateOffset(o[0], o[1], rotation);
          return offsetLatLng(lat0, lng0, rx, ry);
        });

        features.push({
          type: 'Feature',
          properties: { featuretype: 'door', side: sideIndex, doorIndex: doorIndex },
          geometry: { type: 'LineString', coordinates: line }
        });

        // 4) vluchtweg - rode rechthoek buiten bufferzone bij elke deur
        let vluchtwegCorners;
        const currentBuf = [bufN, bufE, bufS, bufW][sideIndex]; // Buffer voor deze zijde

        if (sideProps.axis === 'x') {
          // Horizontale zijde (Noord/Zuid)
          const x1 = -hw + currentPos - 0.1; // 0.1m extra aan linkerkant
          const x2 = x1 + doorLen + 0.2; // doorLen + 0.4m extra (0.1m per kant)
          if (sideIndex === 0) {
            // Noord: vluchtweg naar boven (positieve y richting)
            const y1 = hl;
            const y2 = y1 + currentBuf + 0.8;
            vluchtwegCorners = [[x1, y1], [x2, y1], [x2, y2], [x1, y2], [x1, y1]];
          } else {
            // Zuid: vluchtweg naar beneden (negatieve y richting)
            const y1 = -hl;
            const y2 = y1 - currentBuf - 0.8;
            vluchtwegCorners = [[x1, y1], [x2, y1], [x2, y2], [x1, y2], [x1, y1]];
          }
        } else {
          // Verticale zijde (Oost/West)
          const y1 = hl - currentPos + 0.2; // 0.2m extra aan bovenkant
          const y2 = y1 - doorLen - 0.4; // doorLen + 0.4m extra (0.2m per kant)
          if (sideIndex === 1) {
            // Oost: vluchtweg naar rechts (positieve x richting)
            const x1 = hw;
            const x2 = x1 + currentBuf + 0.8;
            vluchtwegCorners = [[x1, y1], [x2, y1], [x2, y2], [x1, y2], [x1, y1]];
          } else {
            // West: vluchtweg naar links (negatieve x richting)
            const x1 = -hw;
            const x2 = x1 - currentBuf - 0.8;
            vluchtwegCorners = [[x1, y1], [x2, y1], [x2, y2], [x1, y2], [x1, y1]];
          }
        }

        const vluchtwegCoords = vluchtwegCorners.map(corner => {
          const [rx, ry] = rotateOffset(corner[0], corner[1], rotation);
          return offsetLatLng(lat0, lng0, rx, ry);
        });

        features.push({
          type: 'Feature',
          properties: { featuretype: 'vluchtweg', side: sideIndex, doorIndex: doorIndex },
          geometry: { type: 'Polygon', coordinates: [vluchtwegCoords] }
        });

        currentPos += doorLen;
        doorIndex++;
      }
    }
  });

  // 4) roosters - paarse lijnen aan gebouwranden
  if (roosterSides) {
    roosterSides.forEach((sideConfig, sideIndex) => {
      if (!sideConfig || sideConfig === "" || sideConfig.length === 0) return;

      // Bepaal zijde eigenschappen
      const sideProps = [
        { start: [-hw, +hl], end: [+hw, +hl], axis: 'x' }, // Noord (0)
        { start: [+hw, +hl], end: [+hw, -hl], axis: 'y' }, // Oost (1)
        { start: [+hw, -hl], end: [-hw, -hl], axis: 'x' }, // Zuid (2)
        { start: [-hw, -hl], end: [-hw, +hl], axis: 'y' }  // West (3)
      ][sideIndex];

      // Parse array: [afstand1, rooster1, afstand2, rooster2, ...]
      let currentPos = 0;
      let roosterIndex = 0;
      for (let i = 0; i < sideConfig.length; i += 2) {
        const distance = sideConfig[i] || 0;
        const roosterLen = sideConfig[i + 1];

        currentPos += distance;
        if (roosterLen && roosterLen > 0) {
          // Bereken rooster posities op deze zijde
          let p1, p2;

          if (sideProps.axis === 'x') {
            // Horizontale zijde (Noord/Zuid)
            const x1 = -hw + currentPos;
            const x2 = x1 + roosterLen;
            p1 = [x1, sideProps.start[1]];
            p2 = [x2, sideProps.start[1]];
          } else {
            // Verticale zijde (Oost/West)
            const y1 = hl - currentPos;
            const y2 = y1 - roosterLen;
            p1 = [sideProps.start[0], y1];
            p2 = [sideProps.start[0], y2];
          }

          const line = [p1, p2].map(o => {
            const [rx, ry] = rotateOffset(o[0], o[1], rotation);
            return offsetLatLng(lat0, lng0, rx, ry);
          });

          features.push({
            type: 'Feature',
            properties: { featuretype: 'rooster', side: sideIndex, roosterIndex: roosterIndex },
            geometry: { type: 'LineString', coordinates: line }
          });

          currentPos += roosterLen;
          roosterIndex++;
        }
      }
    });
  }

  // 5) MSkabelvak - rode streepjes rechthoek vanaf gebouwgrens
  if (MSkabelvakSides && MSkabelvakLength) {
    MSkabelvakSides.forEach((sideConfig, sideIndex) => {
      if (!sideConfig || sideConfig === "" || sideConfig.length === 0) return;

      // Bepaal zijde eigenschappen (zelfde als deuren)
      const sideProps = [
        { start: [-hw, +hl], end: [+hw, +hl], axis: 'x' }, // Noord (0)
        { start: [+hw, +hl], end: [+hw, -hl], axis: 'y' }, // Oost (1)
        { start: [+hw, -hl], end: [-hw, -hl], axis: 'x' }, // Zuid (2)
        { start: [-hw, -hl], end: [-hw, +hl], axis: 'y' }  // West (3)
      ][sideIndex];

      // Parse array: [afstand1, breedte1, afstand2, breedte2, ...]
      let currentPos = 0;
      let kabelvakIndex = 0;
      for (let i = 0; i < sideConfig.length; i += 2) {
        const distance = sideConfig[i] || 0;
        const kabelvakWidth = sideConfig[i + 1];

        currentPos += distance;
        if (kabelvakWidth && kabelvakWidth > 0) {
          // Bereken MSkabelvak posities op deze zijde - genereer 3 lijnen (exclusief building edge)
          let lines = [];

          if (sideProps.axis === 'x') {
            // Horizontale zijde (Noord/Zuid)
            const x1 = -hw + currentPos;
            const x2 = x1 + kabelvakWidth;
            if (sideIndex === 0) {
              // Noord: kabelvak naar boven (positieve y richting)
              const y1 = hl;
              const y2 = y1 + MSkabelvakLength;
              // 3 lijnen: links, boven, rechts (skip building edge = y1 lijn)
              lines = [
                [[x1, y1], [x1, y2]], // links
                [[x1, y2], [x2, y2]], // boven
                [[x2, y2], [x2, y1]]  // rechts
              ];
            } else {
              // Zuid: kabelvak naar beneden (negatieve y richting)
              const y1 = -hl;
              const y2 = y1 - MSkabelvakLength;
              // 3 lijnen: links, onder, rechts (skip building edge = y1 lijn)
              lines = [
                [[x1, y1], [x1, y2]], // links
                [[x1, y2], [x2, y2]], // onder
                [[x2, y2], [x2, y1]]  // rechts
              ];
            }
          } else {
            // Verticale zijde (Oost/West)
            const y1 = hl - currentPos;
            const y2 = y1 - kabelvakWidth;
            if (sideIndex === 1) {
              // Oost: kabelvak naar rechts (positieve x richting)
              const x1 = hw;
              const x2 = x1 + MSkabelvakLength;
              // 3 lijnen: boven, rechts, onder (skip building edge = x1 lijn)
              lines = [
                [[x1, y1], [x2, y1]], // boven
                [[x2, y1], [x2, y2]], // rechts
                [[x2, y2], [x1, y2]]  // onder
              ];
            } else {
              // West: kabelvak naar links (negatieve x richting)
              const x1 = -hw;
              const x2 = x1 - MSkabelvakLength;
              // 3 lijnen: boven, links, onder (skip building edge = x1 lijn)
              lines = [
                [[x1, y1], [x2, y1]], // boven
                [[x2, y1], [x2, y2]], // links
                [[x2, y2], [x1, y2]]  // onder
              ];
            }
          }

          // Voeg elke lijn toe als aparte feature
          lines.forEach((lineCoords, lineIndex) => {
            const transformedCoords = lineCoords.map(coord => {
              const [rx, ry] = rotateOffset(coord[0], coord[1], rotation);
              return offsetLatLng(lat0, lng0, rx, ry);
            });

            features.push({
              type: 'Feature',
              properties: {
                featuretype: 'MSkabelvak',
                side: sideIndex,
                kabelvakIndex: kabelvakIndex,
                lineIndex: lineIndex // Voor matching tijdens drag
              },
              geometry: { type: 'LineString', coordinates: transformedCoords }
            });
          });

          currentPos += kabelvakWidth;
          kabelvakIndex++;
        }
      }
    });
  }

  // 6) LSkabelvak - groene streepjes rechthoek vanaf gebouwgrens
  if (LSkabelvakSides && LSkabelvakLength) {
    LSkabelvakSides.forEach((sideConfig, sideIndex) => {
      if (!sideConfig || sideConfig === "" || sideConfig.length === 0) return;

      // Bepaal zijde eigenschappen (zelfde als deuren)
      const sideProps = [
        { start: [-hw, +hl], end: [+hw, +hl], axis: 'x' }, // Noord (0)
        { start: [+hw, +hl], end: [+hw, -hl], axis: 'y' }, // Oost (1)
        { start: [+hw, -hl], end: [-hw, -hl], axis: 'x' }, // Zuid (2)
        { start: [-hw, -hl], end: [-hw, +hl], axis: 'y' }  // West (3)
      ][sideIndex];

      // Parse array: [afstand1, breedte1, afstand2, breedte2, ...]
      let currentPos = 0;
      let kabelvakIndex = 0;
      for (let i = 0; i < sideConfig.length; i += 2) {
        const distance = sideConfig[i] || 0;
        const kabelvakWidth = sideConfig[i + 1];

        currentPos += distance;
        if (kabelvakWidth && kabelvakWidth > 0) {
          // Bereken LSkabelvak posities op deze zijde - genereer 3 lijnen (exclusief building edge)
          let lines = [];

          if (sideProps.axis === 'x') {
            // Horizontale zijde (Noord/Zuid)
            const x1 = -hw + currentPos;
            const x2 = x1 + kabelvakWidth;
            if (sideIndex === 0) {
              // Noord: kabelvak naar boven (positieve y richting)
              const y1 = hl;
              const y2 = y1 + LSkabelvakLength;
              // 3 lijnen: links, boven, rechts (skip building edge = y1 lijn)
              lines = [
                [[x1, y1], [x1, y2]], // links
                [[x1, y2], [x2, y2]], // boven
                [[x2, y2], [x2, y1]]  // rechts
              ];
            } else {
              // Zuid: kabelvak naar beneden (negatieve y richting)
              const y1 = -hl;
              const y2 = y1 - LSkabelvakLength;
              // 3 lijnen: links, onder, rechts (skip building edge = y1 lijn)
              lines = [
                [[x1, y1], [x1, y2]], // links
                [[x1, y2], [x2, y2]], // onder
                [[x2, y2], [x2, y1]]  // rechts
              ];
            }
          } else {
            // Verticale zijde (Oost/West)
            const y1 = hl - currentPos;
            const y2 = y1 - kabelvakWidth;
            if (sideIndex === 1) {
              // Oost: kabelvak naar rechts (positieve x richting)
              const x1 = hw;
              const x2 = x1 + LSkabelvakLength;
              // 3 lijnen: boven, rechts, onder (skip building edge = x1 lijn)
              lines = [
                [[x1, y1], [x2, y1]], // boven
                [[x2, y1], [x2, y2]], // rechts
                [[x2, y2], [x1, y2]]  // onder
              ];
            } else {
              // West: kabelvak naar links (negatieve x richting)
              const x1 = -hw;
              const x2 = x1 - LSkabelvakLength;
              // 3 lijnen: boven, links, onder (skip building edge = x1 lijn)
              lines = [
                [[x1, y1], [x2, y1]], // boven
                [[x2, y1], [x2, y2]], // links
                [[x2, y2], [x1, y2]]  // onder
              ];
            }
          }

          // Voeg elke lijn toe als aparte feature
          lines.forEach((lineCoords, lineIndex) => {
            const transformedCoords = lineCoords.map(coord => {
              const [rx, ry] = rotateOffset(coord[0], coord[1], rotation);
              return offsetLatLng(lat0, lng0, rx, ry);
            });

            features.push({
              type: 'Feature',
              properties: {
                featuretype: 'LSkabelvak',
                side: sideIndex,
                kabelvakIndex: kabelvakIndex,
                lineIndex: lineIndex // Voor matching tijdens drag
              },
              geometry: { type: 'LineString', coordinates: transformedCoords }
            });
          });

          currentPos += kabelvakWidth;
          kabelvakIndex++;
        }
      }
    });
  }

  return { type: 'FeatureCollection', features };
}
// --- einde energiehuisje helpers ---

export { hexToRgb, interpolateColor, rotateOffset, offsetLatLng, createEnergyHouseGeoJSON };
